export const GET_HISTORY = "GET_HISTORY";
export const FETCH_HISTORY_DATA = "FETCH_HISTORY_DATA";
export function getHistory(payload) {
    return { type: GET_HISTORY, payload};
  }

  export function fetchHistoryData(
    name,
    offset,
    limit
  ) {
    return {
      type: FETCH_HISTORY_DATA,
      name,
      offset,
      limit
      
    };
  }


// WEBPACK FOOTER //
// ./src/shells/HistoryLeaderboard/actions.js